import angular from 'angular';

import { $notification } from './notification.service';

export default angular
  .module('ui.notification', [])
  .service('$notification', $notification);
